import axios from "axios";
import config from "../config";
import { SearchResponse } from "./ResponseModels/SearchResponse";
import { FakeAxiosResponse } from "./FakeAxiosResponse";
import FollowedResponseFake from "./json/FollowedResponseFake.json";

export async function GetFollowingWoModel(
  pageSize: number,
  lastEvaluatedKey: string = null,
) {
  let response = null;

  if (!config.useFakeModels) {
    response = axios
      .get<SearchResponse>(config.getFollowingEndpoint, {
        params: {
          pageSize: pageSize,
          lastEvaluatedKey: lastEvaluatedKey,
        },
      })
      .catch((e) => {
        console.error("There was an error!", e);
      });
  } else {
    const responseData = JSON.parse(JSON.stringify(FollowedResponseFake));

    response = FakeAxiosResponse(responseData, 200);
  }

  return response;
}
